import React from 'react';
import styled from '@emotion/styled';

interface IVehicleTypeCard {
  vehicleName: string;
  imageSrc: string;
}

const VehicleTypeCard: React.FC<IVehicleTypeCard> = ({ vehicleName, imageSrc }) => {
  return (
    <CardContainer>
      <TextContainer>
        <VehicleName>{vehicleName}</VehicleName>
      </TextContainer>
      <VehicleImage src={imageSrc} alt={vehicleName} />
    </CardContainer>
  );
};

export default VehicleTypeCard;

const CardContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
  max-width: 380px;
  height: 450px;
  overflow: hidden;
  transition: transform 0.2s ease-in-out;

  &:hover {
    transform: translateY(-5px);
  }

  @media (max-width: 1024px) {
    height: 380px;
  }

  @media (max-width: 768px) {
    height: 380px;
    padding: 15px;
  }

  @media (max-width: 480px) {
    width: 145px;
    height: 210px;
    padding: 0;
  }
`;

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  height: 100%;
  width: 70%;
  padding: 20px;
  background-color: #fff0f2;
  border-radius: 12px;

  @media (max-width: 480px) {
    width: 120px;
    padding: 10px;
  }
`;

const VehicleName = styled.h3`
  font-size: 18px;
  font-weight: 600;
  color: #000;
  margin-bottom: 15px;
  text-align: center;
  flex-shrink: 0;

  @media (max-width: 480px) {
    font-size: 16px;
    font-weight: 500;
  }
`;

const VehicleImage = styled.img`
  position: absolute;
  left: 0;
  bottom: 40px;
  width: 90%;
  height: auto;
  object-fit: contain;
//   max-height: 180px;
  flex-grow: 1;
  z-index: 10;

  @media (max-width: 768px) {
    bottom: 20px;
    // width: 70%;
    max-height: 180px;
  }

  @media (max-width: 480px) {
    max-height: 120px;
    bottom: 10px;
    right: 0;
  }

`;